import * as toastr from 'toastr'
import i18n from '@/lang/i18n'

export class ToastUtils {
    private static _toastrOptions: ToastrOptions = {
        timeOut: 3000,
        positionClass: 'toast-top-right',
        hideDuration: 500,
        closeButton: true
    }

    static showToastSuccess(message: string = i18n.tc('component.modalShowSuccess.title'), title?: string) : void {
        toastr.success(message, title, ToastUtils._toastrOptions)
    }
    static showToastInfo(message: string = i18n.tc('component.modalShowInfo.title'), title?: string) {
        toastr.info(message, title, ToastUtils._toastrOptions)
    }
    static showToastNotification(message: string = i18n.tc('component.modalShowNotification.title'), title?: string) {
        toastr.warning(message, title, ToastUtils._toastrOptions)
    }
    static showToastAlert(message: string = i18n.tc('component.modalShowAlert.title'), title?: string) {
        toastr.error(message, title, ToastUtils._toastrOptions)
    }
}
